import React from 'react';
import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { Sidebar, SIDEBAR_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from './Sidebar';
import { Topbar } from './Topbar';
import { AppShellFooter } from '../ui/PlatformFooter';
import { brandColors } from '../../theme/appTheme';
import { useModules } from '../../contexts/ModuleContext';
import { useAppTheme } from '../../contexts/ThemeContext';

interface AppShellProps {
  children: React.ReactNode;
  title?: string;
}

export const AppShell: React.FC<AppShellProps> = ({ children, title }) => {
  const { collapsed } = useModules();
  const { brand } = useAppTheme();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const sidebarWidth = isMobile ? 0 : (collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: brand.green50 || brandColors.contentBg }}>
      <Sidebar />
      <Box sx={{
        flexGrow: 1,
        width: isMobile ? '100%' : `calc(100% - ${sidebarWidth}px)`,
        ml: isMobile ? 0 : `${sidebarWidth}px`,
        transition: 'margin 0.2s, width 0.2s',
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}>
        <Topbar title={title} />
        <Toolbar />
        <Box sx={{ p: { xs: 1.25, sm: 2, md: 2.5 }, minWidth: 0, flex: 1, maxWidth: '100%', overflowX: 'hidden' }}>
          {children}
        </Box>
        <AppShellFooter />
      </Box>
    </Box>
  );
};

// Backward compatible alias
export const AppLayout = AppShell;
